'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.SignUpEndpoint = exports.AuthenticationMethod = exports.MaritalStatus = exports.Currency = void 0;
var Currency;
(function (Currency) {
    Currency["EUR"] = "EUR";
    Currency["USD"] = "USD";
    Currency["GBP"] = "GBP";
    Currency["DKK"] = "DKK";
    Currency["NOK"] = "NOK";
    Currency["SEK"] = "SEK";
    Currency["CAD"] = "CAD";
    Currency["AUD"] = "AUD";
    Currency["NZD"] = "NZD";
    Currency["TRY"] = "TRY";
    Currency["PLN"] = "PLN";
    Currency["CHF"] = "CHF";
    Currency["RUB"] = "RUB";
    Currency["JPY"] = "JPY";
    Currency["UAH"] = "UAH";
    Currency["BRL"] = "BRL";
    Currency["INR"] = "INR";
    Currency["THB"] = "THB";
    Currency["KRW"] = "KRW";
    Currency["PEN"] = "PEN";
    Currency["CLP"] = "CLP";
    Currency["MXN"] = "MXN";
    Currency["HRK"] = "HRK";
    Currency["ZAR"] = "ZAR";
    Currency["HKD"] = "HKD";
    Currency["NAD"] = "NAD";
    Currency["MKD"] = "MKD";
    Currency["HUF"] = "HUF";
    Currency["RON"] = "RON";
    Currency["ARS"] = "ARS";
    Currency["SWP"] = "XSC";
    Currency["GLD"] = "XGC";
    Currency["PHP"] = "PHP";
    Currency["XFC"] = "XFC";
})(Currency = exports.Currency || (exports.Currency = {}));
var MaritalStatus;
(function (MaritalStatus) {
    MaritalStatus["MARRIED"] = "Married";
    MaritalStatus["UNMARRIED"] = "Unmarried";
    MaritalStatus["WIDOW"] = "Widow";
    MaritalStatus["CIVIL_UNION_PARTNER"] = "CivilUnionPartner";
    MaritalStatus["DOMESTIC_PARTNER"] = "DomesticPartner";
})(MaritalStatus = exports.MaritalStatus || (exports.MaritalStatus = {}));
var AuthenticationMethod;
(function (AuthenticationMethod) {
    AuthenticationMethod["ONE_FACTOR"] = "ONE_FACTOR";
    AuthenticationMethod["TWO_FACTOR_BY_SMS"] = "TWO_FACTOR_BY_SMS";
    AuthenticationMethod["TWO_FACTOR_BY_EMAIL"] = "TWO_FACTOR_BY_EMAIL";
    AuthenticationMethod["TWO_FACTOR_BY_KBA"] = "TWO_FACTOR_BY_KBA";
})(AuthenticationMethod = exports.AuthenticationMethod || (exports.AuthenticationMethod = {}));
var SignUpEndpoint;
(function (SignUpEndpoint) {
    SignUpEndpoint["SignUpV2"] = "users/signUpV2";
    SignUpEndpoint["QuickSignUpV2"] = "users/quickSignUpV2";
    SignUpEndpoint["SignUpV2SC"] = "users/signUpV2SC";
    SignUpEndpoint["SignUpLOTBA"] = "users/signUpLOTBA";
    SignUpEndpoint["SignUpONJN"] = "users/signUpONJN";
    SignUpEndpoint["SignUpAGCO"] = "users/signUpAGCO";
    SignUpEndpoint["SignUpUKGC"] = "users/signUpUKGC";
    SignUpEndpoint["SignUpEMTA"] = "users/signupEMTA";
    SignUpEndpoint["QuickSignUpEMTA"] = "users/quickSignUpEMTA";
})(SignUpEndpoint = exports.SignUpEndpoint || (exports.SignUpEndpoint = {}));
